import { render, staticRenderFns } from "./NoGymsFound.vue?vue&type=template&id=632b49cd&scoped=true"
import script from "./NoGymsFound.vue?vue&type=script&lang=js"
export * from "./NoGymsFound.vue?vue&type=script&lang=js"
import style0 from "./NoGymsFound.vue?vue&type=style&index=0&id=632b49cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b49cd",
  null
  
)

export default component.exports